import React, { useEffect, useCallback, memo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import FaqBeta from "./Faqbeta";
import {isTutorial, isIconButnActive, isOnBoardHeader, fromCloseHistory}  from "../Services/Redux/Reducers/commonSlice";
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

function OnboardHeader(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const modalFlag = useSelector((state) => state.feedBack.appFeedBackModal);
  const isFaqFade = useSelector((state) => state.common.faqFade);
  const isIBtnActive = useSelector((state)=>state.common.isIconButnActive);
  const closeHistory = useSelector((state)=>state.common.fromCloseHistory);

  const {
    // loading,
    t,
  } = useLanguage();

  useEffect(() => {    
    // to scroll to the top of the offcavas - 253
    if(isIBtnActive) {
      const el = document.getElementById("faqCanvas");      
      if(el) {
        el.scrollIntoView({
          behavior: 'instant'
        });
      }
    }
  }, [isIBtnActive]);

  const handleFaqOpen = useCallback(() => {
    dispatch(isIconButnActive(true));
  }, [dispatch]);

  const handleInspirationClick = useCallback(() => {
    dispatch(isTutorial(true));
    dispatch(isOnBoardHeader(false));
    dispatch(fromCloseHistory(true));
  }, [dispatch]);

  const handleHistoryClick = useCallback(() => {
    props.openHistoryModal();
  }, [props.openHistoryModal]);

  return (
    <div id="onboardHeader">
      <div className={`${modalFlag ? 'bckClr' : ''} col-12 d-flex align-items-center justify-content-between onboard-header highIndex`}>
        <div>
          <button
            onClick={handleFaqOpen}
            name="faqInfoButton"
            disabled={modalFlag}
            className={`${closeHistory ? "" : "fadein-logo"} faq-btn p-0 d-flex align-items-center justify-content-center 
            ${modalFlag && "disablefaq"} ${isFaqFade && "faq_fade"}`}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasLeft"
            aria-controls="offcanvasLeft"
          >
            <img
              className="hamburger-menu-icon"
              src={
                location.pathname === "/" || location.pathname === "/useronboardPOC"
                  ? isIBtnActive ? "/static/assets/iconWht.svg" : "/static/assets/updated_faq.svg"
                  : "/static/assets/chat_menu_icon.svg"
              }
              alt="menu"
            />
          </button>
        </div>
        <div className="d-flex" style={{gap:"10px"}}>
        {(props.carouselData && props.carouselData?.data?.length != 0) ? (
        <div className="d-flex justify-content-center align-items-center">
            <button name="historyButton" onClick={handleHistoryClick} className={`onboard_header_btn ${closeHistory ? "" : "fadein-logo"}`} type="button" aria-controls="offcanvasRight">
              <span className="onboard_header_btn_txt">{t("HISTORY")}</span></button>
        </div>
        ):<div></div>}
        <div className="d-flex justify-content-center align-items-center">
          <button name="onboardTutorial" className={`onboard_header_btn ${closeHistory ? "" : "fadein-logo"}`}
            onClick={handleInspirationClick}
            disabled={modalFlag}>
            <span className="onboard_header_btn_txt">{t("INSPIRATION")}</span>
          </button>
        </div>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasLeft"
        aria-labelledby="offcanvasLeftLabel"
      >
        <div className="sidebar-body offcanvas-body">
          <FaqBeta />
        </div>
      </div>
    </div>
  );
}

export default memo(OnboardHeader);
